// TODO This is more of a LEGO component, so shouldn't be at the top-level
define('glu/grid',['require','./grid/gridLayout'],function(require) {
    'use strict';

    return require('./grid/gridLayout');
});

